module.exports = __webpack_public_path__ + "static/media/img-talent-manager@2x.5c139577.png";